import { render, staticRenderFns } from "./RouteMakingViewRoute.vue?vue&type=template&id=bc3c8a9c&scoped=true&"
import script from "./RouteMakingViewRoute.vue?vue&type=script&lang=js&"
export * from "./RouteMakingViewRoute.vue?vue&type=script&lang=js&"
import style0 from "./RouteMakingViewRoute.vue?vue&type=style&index=0&id=bc3c8a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3c8a9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
